import React from "react";
import Title from "../Components/Title";
import ImageContent from "../Components/ImageContent";
import clientImage from "../assets/images/Clients.png";
import ClientContent from "../Components/ClientContent";

/* Client Images*/
import EY from "../assets/images/ernstandyoung_logo.png";

function Sponsors() {
   return (
      <div className=" lg:w-[70%] w-[85%] max-h-100 m-auto flex flex-col mt-[5%] gap-[5rem] lg:gap-[10rem]">
         <Title
            Header="Our Sponsors"
            Body="We are grateful to our sponsors who support our mission and make our work possible. Their partnership enables us to continue delivering exceptional results."
         />
         <section className="flex flex-col gap-[5rem] lg:gap-[3rem]">
            <ClientContent
               Title="EY (Ernst & Young)"
               Body="A global professional services firm focused on 'Building a better working world' through its integrated services in assurance, consulting, tax, and strategy and transactions."
               Image={EY}
               AltText="EY"
            />
         </section>

         <div className="w-[100%] h-[100%] overflow-hidden">
            <ImageContent
               Header="Want to work with us?"
               Body="Let's get in touch"
               ButtonText="Contact Us"
               execute={() => {
                  const email = "axismd@sfu.ca";
                  navigator.clipboard.writeText(email).then(() => {
                     alert("Email copied to clipboard!");
                  });
               }}
               Image={clientImage}
               AltText="Organization"
            />
         </div>
      </div>
   );
}

export default Sponsors;
